import script from "./ForgotPasswordBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotPasswordBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ForgotPasswordBtn.vue?vue&type=style&index=0&id=56bf63de&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bf63de"]])

export default __exports__